<template>
    <div class="flex ">
          <div v-for="(network, key) in socialNetworks" :key="key" class="network-object font-semibold text-sm cursor-pointer py-2 px-3 flex items-center" @click="toNetwork(network)">
          <img class="mr-2" :src="require(`@/assets/icons/${network.type}.svg`)" alt=""> ID {{network.id}}
          </div>
          </div>
</template>
<script>
export default {
  name: 'networks',
  props: ['networkRaw'],
  computed: {
    socialNetworks() {
      /* добавляем тип объекту */
      const networks = Object.assign({}, this.networkRaw);
      const arr = [];
      Object.keys(networks).forEach((network) => {
        const object = {};
        object.type = network;
        object.id = networks[network];
        if (object.type != 'google' && object.type != 'facebook') {
          arr.push(object);
        }
      });
      return arr;
    },
  },
  methods: {
    toNetwork(network) {
      let idPrefix = '';
      const copy = Object.assign({}, network);
      if (copy.type == 'vkontakte') {
        copy.type = 'vk';
        idPrefix = /[0-9]/.test(network.id) ? 'id' : '';
      }
      if (copy.type == 'facebook') {
        idPrefix = /[0-9]/.test(network.id) ? 'profile.php?id=' : '';
      }
      window.open(`http://www.${copy.type}.com/${idPrefix}${network.id}`, '_blank');
    },
  },
};
</script>
<style scoped>
.network-object {
    border: 1px solid #DADADA;
    border-radius: 3px;
    background: rgba(74, 0, 69, 0.05);
    color: #4A0045;
    transition: all .5s ease
  }
  .network-object:hover {
   transform: translateY(-5px)
  }
</style>
